import { useState } from "react";
import { Copy, Check, Mail } from "lucide-react";
import { LogoMark } from "./LogoMark";
import { Reveal } from "./Reveal";

const EMAIL = "majknagy21@gmail.com";

export const Footer = ({ onNotify }) => {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      onNotify("Email copied", EMAIL);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      onNotify("Contact", EMAIL);
    }
  };

  return (
    <footer id="contact" className="relative overflow-hidden border-t border-sky-400/10" data-testid="footer">
      <div className="pointer-events-none absolute inset-x-0 bottom-0 select-none overflow-hidden">
        <p className="font-serif-display translate-y-[28%] text-center text-[22vw] leading-none tracking-tight text-sky-400/[0.05]">
          Neyrein
        </p>
      </div>
      <div className="relative z-10 mx-auto max-w-7xl px-6 pb-56 pt-24 lg:px-10">
        <div className="grid gap-14 md:grid-cols-2">
          <Reveal>
            <div className="flex items-center gap-3">
              <LogoMark size={40} />
              <div>
                <p className="font-serif-display text-2xl text-slate-50">Neyrein</p>
                <p className="text-xs text-slate-500">Binding your life to calmer money habits.</p>
              </div>
            </div>
            <p className="mt-8 max-w-sm text-sm leading-relaxed text-slate-500">
              Neyrein will be available for download from the Google Play Store and the Apple App
              Store, with desktop builds posted in the version history above.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-mono-num text-xs uppercase tracking-[0.3em] text-sky-400">Contact</p>
            <button
              onClick={copyEmail}
              data-testid="footer-email-copy-btn"
              className="group mt-5 flex items-center gap-4 rounded-2xl border border-sky-400/20 bg-[#132342]/50 px-6 py-4 transition-all duration-300 hover:border-sky-400/50 hover:shadow-[0_12px_40px_-12px_rgba(56,189,248,0.4)]"
            >
              <Mail size={18} className="shrink-0 text-sky-300" />
              <span className="font-mono-num text-sm text-slate-200 sm:text-base">{EMAIL}</span>
              {copied ? (
                <Check size={16} className="text-emerald-400" />
              ) : (
                <Copy size={16} className="text-slate-500 transition-colors group-hover:text-sky-300" />
              )}
            </button>
            <div className="mt-10 flex flex-wrap gap-8 text-sm text-slate-500">
              <a href="#overview" className="transition-colors hover:text-sky-300" data-testid="footer-link-overview">
                Overview
              </a>
              <a href="#features" className="transition-colors hover:text-sky-300" data-testid="footer-link-features">
                Features
              </a>
              <a href="#versions" className="transition-colors hover:text-sky-300" data-testid="footer-link-versions">
                Versions
              </a>
            </div>
          </Reveal>
        </div>
        <div className="mt-20 flex flex-wrap items-center justify-between gap-4 border-t border-sky-400/10 pt-8 text-xs text-slate-600">
          <p>© 2026 Neyrein. All rights reserved.</p>
          <p className="font-mono-num uppercase tracking-[0.2em]">Calmer money habits</p>
        </div>
      </div>
    </footer>
  );
};
